export interface CommentDetails {
  user: string;
  comment: string;
}
